export default __webpack_public_path__ + "static/media/Termcondition.d41a825d.svg";